module.exports = __webpack_public_path__ + "static/media/teachersPet.4c76a482.png";